<template>
  <component :is="compName" />
</template>

<script>
  import { mapGetters } from 'vuex'

  import EmptyLayout from './EmptyLayout.vue'
  import HorizontalLayout from './HorizontalLayout.vue'
  import VerticalLayout from './VerticalLayout.vue'

  export default {
    name: 'Layout',
    components: { EmptyLayout, HorizontalLayout, VerticalLayout },
    computed: {
      ...mapGetters({
        layout: 'settings/layout',
        fullScreenState: 'routes/fullScreenState',
      }),

      compName() {
        if (this.fullScreenState) return 'EmptyLayout'

        return this.layout === 'horizontal'
          ? 'HorizontalLayout'
          : 'VerticalLayout'
      },
    },
    watch: {
      $route: {
        handler() {
          const { name } = this.$route
          if (name) {
            this.$store.dispatch('tabsBar/addVisitedRoute', this.$route)
          }
        },
        immediate: true,
      },
    },
    mounted() {
      this.$store.dispatch('settings/openSideBar')
    },
  }
</script>
